<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="480px"
            @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="bt_wrap detail" style="width: 480px; min-width: 480px;">
        <div class="popup_top" style="height: 180px;">
          <p style="padding-top: 15px;"><span class="b_title" style="font-size: 20pt;  font-weight: 700">영상회의실 사전예약시 유의사항</span></p>
          <div style="line-height: 1.1; margin-top: 35px; width: 95%; font-weight: 300">1. 반드시 사전에 영상회의실 관리부서와 협의하여 <br> <span style="margin-left: 20px;">예약하신 후 사용하시기 바랍니다.</span></div>
          <div style="line-height: 1.1; margin-top: 20px; width: 95%; font-weight: 300">2. 예약한 시간 동안에만 영상회의 이용이 가능합니다. <br> <span style="margin-left: 20px;">예약된 종료시간 이후 영상회의는 자동 폐쇄됩니다.</span></div>
        </div>
        
        <div class="btnArea detail" style="padding-bottom: 0px; margin-top: 10px;">
          <button class="btn type3" @click="closeDialog">확인</button>
        </div>
      </div>
    </v-card>

    
  </v-dialog>
</template>
<script>
export default {
  props: [
    'dialog',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      attendees: [],
      conStyle: {
        conferenceTitleW: 22,
        conferenceCreatorW: 8,
        conferenceDateW: 33,
        conferenceJoinNumW: 17,
        conferenceCreatorKeyW: 10,
        conferencePasswordW: 10
      },
      allAttendeeDialog: {
        dialog: false,
        attendees: []
      },
      allConferenceRoomDialog: {
        dialog: false,
        rooms: []
      },
      isCreator: false
    };
  },
  mounted () {
    this.loading = false;
  },
  methods: {
    async addPeople () { /* 추가초대 버튼 Func */
      console.log('addPeople');
    },
    async initMeetingList () {
      this.attendees = this.meeting.attendees;
    },
    checkHost () {
      if (this.$store.state.user.email === this.meeting.creator.email) {
        this.isCreator = true;
      } else {
        this.isCreator = false;
      }
    },
    showAllAttendees (attendees) {
      this.allAttendeeDialog.dialog = true;
      this.allAttendeeDialog.attendees = attendees;
    },
    closeAllAttendees () {
      this.allAttendeeDialog.dialog = false;
      this.allAttendeeDialog.attendees = [];
    },
    showAllConferenceRoom (meetingRoom) {
      this.allConferenceRoomDialog.dialog = true;
      this.allConferenceRoomDialog.rooms = meetingRoom;
    },
    closeAllConferenceRoom () {
      this.allConferenceRoomDialog.dialog = false;
      this.allConferenceRoomDialog.rooms = [];
    }
  }
};
</script>
<style scoped>
.bt_wrap {
  background: #604af3;
}
.dataTable table td:nth-child(odd) {
  background: #fff;
  width: 145px;
  padding-left: 40px;
}

.dataTable table.info td:nth-child(odd) {
  background: #fff;
  padding-left: 0px;
}

.dataTable table.detail td:nth-child(2n) {
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #333;
  vertical-align: top;
}

.type3 {
  width: 100px;
  border-radius: 8px;
  background: white;
  color: #604af3;
  padding: 0;
  text-align: center;
  height: 48px;
}

.dataTable table td {
  height: 66px;
  background: #fff;
  letter-spacing: -2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #333;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
}

.v-dialog {
  max-height: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ConferenceAgreeDialog.vue